<template>
  <div>
    <div class="box">

      <div class="top_height">
        <span style="font-size: 36px;">拍卖结果</span>

      </div>
      <div class="top_height_top">
        <div class="button1" :class="{ 'button2': abc == 1 }" @click="but1">
          按拍卖会
          <span class="active" v-if="this.abc == 1"></span>
        </div>
        <div class="button1" :class="{ 'button2': abc == 0 }" @click="but2">
          按拍卖专场
          <span class="active" v-if="this.abc == 0"></span>
        </div>

      </div>
      <div class="top_height_body">
        <div class="body_left">
          <div class="body_left_top">
            <span style="font-size:12px; color: #333333;">筛选</span>
            <button style="width: 42px;height: 20px;border: 1px solid #333333;border-radius: 4px;line-height: 18px;text-align: center;font-size: 12px;font-family: Source Han Sans CN;font-weight: 400;color: #333; display: flex; justify-content: center; align-items: center;" @click="reset">重置</button>
          </div>
          <div class="body_left_top2">
            <input type="text" placeholder="拍卖会/拍卖专场" v-model="keyword" />
            <img src="https://www.cguardian.com/gdmall-auction/static/img/search_darkblue-a4c13fda.svg" @click="search" />

          </div>
          <div class="body_left_top3">
            <span style="font-weight: bold; font-size: 14px; margin-bottom: 14px;">日期选择</span>
            <el-select v-model="value" placeholder="年份不限" style="margin-top: 14px;">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <!-- <div class="body_left_top4">
            <span style="margin-left: 15px; font-size: 15px; font-weight: bold;">拍卖会</span>
            <div class="button7" @click="toggleRotation" :class="{ rotatePlus: isPlus, rotateX: !isPlus }">x</div>
          </div> -->

        </div>
        <div class="body_right" v-show="this.abc == 1">
          <el-table
            :data="tableData1"
            style="width: 100%"
            row-key="id"
            :header-row-style="{color:'black'}"
            :tree-props="{children: 'times', hasChildren: 'hasChildren'}"
			      @row-click="clickRow">
            <el-table-column
              prop="pai_start_time"
              label="开始日期"
              width="140"
              align= "center" >
            </el-table-column>
            <el-table-column
              prop="title"
              label="拍卖场次"
              width="260"
              align= "center"
			  >
            </el-table-column>
            <el-table-column
              prop="address"
              label="拍卖地址"
              width="220"
              align= "center">
            </el-table-column>
            <el-table-column
              prop="number"
              label="拍品数量"
              width="100"
              align= "center">
            </el-table-column>
            <el-table-column
              prop="total"
              label="总成交价"
              width="180"
              align= "center"
            >
              <template slot-scope="scope">
				  <el-dropdown trigger="hover" @command="handleCommand(scope.row,$event)" >
                <div class="item_scope">
                  <span>{{scope.row.total}}</span>
				  
                  <div v-if="!scope.row.times" class="download_icon">
                         <img src="https://www.cguardian.com/gdmall-auction/static/img/download_darkblue-535f629d.svg" />
                        <el-dropdown-menu slot="dropdown" v-show="dropdownVisible">
                           <el-dropdown-item command="item1" >重要声明</el-dropdown-item>
                           <el-dropdown-item command="item2" >成交价表</el-dropdown-item>
                           <el-dropdown-item command="item3" >拍品状态报告</el-dropdown-item>
                           <el-dropdown-item command="item4" >电子图录</el-dropdown-item>
                           
                         </el-dropdown-menu>

                    <!-- <div v-if="!scope.row.times"  class="other_item">
                      <ul>
                        <li>重要声明</li>
                        <li>成交价表</li>
                        <li>拍品状态报告</li>
                        <li>电子图录</li>
                      </ul>
                    </div> -->
                  </div>
				  
                </div>
				</el-dropdown>
              </template>
            </el-table-column>
          </el-table>
		  <div class="container" v-if="total1 > 10">
		  	<div class="row">
		  		<el-pagination background :page-size='10' layout="prev, pager, next" @current-change="pageChange1"
		  			:total="total1">
		  		</el-pagination>
		  	</div>
		  </div>
        </div>
		<div class="body_right" v-show="this.abc == 0">
			<div class="container">
				<div class="row">
					<div class="post-item col-md-4" v-for="(item,index) in tableData2" :key="item.id" @click="go('changciDetail',item)">
						<figure class="zoom-effect">
							<div class="zoom-in"><img :src="item.image" style="height: 200px;object-fit: cover"
									alt="stories" class="blogImg img-fluid"></div>
						</figure>
						<div class="story-title-wrap mt-3">
							<h4 class="story-title">{{item.title}}</h4>
							<div class="post-meta">总成交价：{{item.total}}</div>
							<div class="post-meta">拍卖总数：{{item.number}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="container" v-if="total2 > 10">
				<div class="row">
					<el-pagination background :page-size='10' layout="prev, pager, next" @current-change="pageChange2"
						:total="total2">
					</el-pagination>
				</div>
			</div>
		</div>
	  </div>


    </div>



  </div>

</template>

<script>
import {paiList} from "../api/api";
import {
  defineComponent
} from 'vue'
import router from "../router";

export default defineComponent({
  name: "result",
  data() {
    return {
      abc: 1,
      year:'',
      keyword:"",
      options: [{
        value: '',
        label: '年份不限'
      }],
      tableData1: [],
      tableData2: [],
      value: '',
	  page1: 1,
	  page2: 1,
	  total1:null,
	  total2:null,
	  dropdownVisible: false,
    }
  },
  created() {
    this.list()
  },
  mounted() {
  	this.generateYearOptions()
  },
  methods: {
	  abc(e){
		// console.log(e,'85632')
	  },
	   handleCommand(i,u) {
		 //   this.$router.push(
			// "/tupian"
		 //   )

		   // console.log(i,u,"666")
	          
			  if(u == 'item1'){
				 
				 this.$router.push({
					 path:"/tupian",
					 query:{
						 statement:i.statement
					 }
				 })
				 
			  }else if(u == 'item2'){
				  this.$router.push({
				  					 path:"/tupian",
				  					 query:{
				  						 statement:i.price_excel
				  					 }
				  })
					// 
			  }else if(u == 'item3'){
				  this.$router.push({
				  					 path:"/tupian",
				  					 query:{
				  						 statement:i.report
				  					 }
				  })
			  				   // 
			  }else if(u == 'item4'){
				  this.$router.push({
				  					 path:"/tupian",
				  					 query:{
				  						 statement:i.price_excel
				  					 }
				  })
			  			// 	  
			  }
	        },
	 
	  showDropdown() {
	        this.dropdownVisible = true;
	      },
	      hideDropdown() {
	        this.dropdownVisible = false;
	      },
	   generateYearOptions() {
	        const currentYear = new Date().getFullYear();
	        const startYear = 1990; // 开始的年份，可以根据需求调整
	        for (let year = currentYear; year >= startYear; year--) {
	          this.options.push({
	            value: year.toString(),
	            label: year.toString(),
	          });
	        }
	      },
	  clickRow(row, column, event) {
		  // console.log(row,'row')
		  // console.log(column,'column')
		  // console.log(event,'event')
		  if(!row.times){
			  this.go('changciDetail',row)
		  }
	  },
	  pageChange1(e) {
	  	// console.log(e)
	  	this.page1 = e
	  	this.list()
	  },
	  pageChange2(e) {
	  	// console.log(e)
	  	this.page2 = e
	  	this.list2()
	  },
	  go(name,e){
		router.push(
		  {
			name,
			query:{
			  id:e.id,
			  type:2
			}
		  }
		)
	  },
    search(){
		if(this.abc == 1){
			this.list()
		}else {
			this.list2()
		}
    },
    but1() {
      this.abc = 1
	  this.page1 = 1
	  this.list()
    },
    but2() {
      this.abc = 0
	  this.page2 = 1
	  this.list2()
    },
    list(){
		// console.log('iiiiiii')
      paiList({
        year:this.value,
        keyword:this.keyword,
		page:this.page1
      }).then(res => {
        // console.log(res,'打印res999')
        this.tableData1 = res.data.data.list.data
		this.total1 = res.data.data.list.total
        // this.classArr2 = res.data.data.list
      })
    },
	list2(){
		console.log('jjjj')
      paiList({
        year:this.value,
        keyword:this.keyword,
		is_profession: 1,
		page:this.page2
      }).then(res => {
        console.log(res,'打印res999')
        this.tableData2 = res.data.data.list.data
		this.total2 = res.data.data.list.total
        // this.classArr2 = res.data.data.list
      })
    },
    reset(){
      this.value = ""
      this.keyword = ""
    }

  }


})
</script>

<style scoped>
@import 'css/main.css';

.box {
  width: 100%;


}

.top_height {

  width: 1210px;
  /* height: 200px; */
  margin: 0 auto;
}

.top_height_top {

  display: flex;
  justify-content: center;
  width: 1210px;
  margin: 0 auto;

}

.button1 {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  padding: 0 30px;
  line-height: 45px;
  cursor: default;
  position: relative;
  color: #9a9a9a;
}

.button1:hover {

  color: black !important;
}

.button2 {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  padding: 0 30px;
  line-height: 45px;
  cursor: default;
  position: relative;
  color: black !important;

}

.active {
  color: #142133;
  border-bottom: 2px solid #a73843;
  width: 30px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.top_height_body {
  width: 1210px;
  margin: 0 auto;
  display: flex;
  margin-top: 30px;
}

.body_left {
  width: 210px;

}

.body_left_top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.body_left_top2{
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 42px;
  border-bottom: 1px solid rgba(175, 177, 196, .2);
  margin-top: 18px;
}
.body_left_top2:hover{
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 42px;
  border-bottom: 1px solid black;
  margin-top: 18px;
}
.body_left_top2 input{
  display: block;
  width: 190px;
  height: 40px;
  font-size: 14px;
  border: 0;
  outline: none;
}
.body_left_top2 img{
  width: 16px;
  height: 16px;
}
.body_left_top3{
  margin-top: 30px;

}
.body_left_top4{
  margin-top: 30px;
  height: 38px;
  border-top: 1px solid rgba(175, 177, 196, .2);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 8px;
}

.item_scope{
  display: flex;
  align-items: center;
  justify-content: center;
}
.item_scope span{
  margin: 0 10px;
}
.download_icon{
  position: relative;
}
.item_scope img:hover + .other_item{
  display: block;
}
.other_item{
  width: 100px !important;
  height: 136px;
  background: #ffffff;
  border: 1px solid #d7d7d7;
  border-radius: 4px;
  display: none;
  position: absolute;
  top: 20px;
  right: 0;
  padding: 0;
  z-index: 20 !important;
}
.other_item ul{
  height: 100%;
  list-style: none;
  padding-left: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.other_item:hover{
  display: block;
}
.other_item ul li:hover{
  height: 44px;
}
.other_item ul li{
  color: #75808f;
  height: 34px;
  line-height: 34px;
  text-align: center;
}
.other_item ul li:hover{
   color: #333;
   font-weight: blod;
   height: 44px;
  cursor: pointer;
 }
.body_right {
  margin-left: 130px;
}
</style>



// WEBPACK FOOTER //
// src/view/result.vue